import { render, staticRenderFns } from "./UsgsHeader.vue?vue&type=template&id=a5877752&scoped=true"
var script = {}
import style0 from "./UsgsHeader.vue?vue&type=style&index=0&id=a5877752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5877752",
  null
  
)

export default component.exports